import React from 'react';
import './Avatar.css';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
const Avatar = () => {
    return (
        <div className='avatar'>
            <AccountCircleIcon />
        </div>
    );
};

export default Avatar;
